import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { AlertTriangleIcon, LayoutGridIcon, MonitorIcon, SparklesIcon } from 'lucide-react';
import { currentStateAssessment } from '../data/abbviePro';
const icons = [LayoutGridIcon, MonitorIcon, AlertTriangleIcon, SparklesIcon];
const tones: Record<string, string> = {
  neutral: 'bg-white border border-slate-200',
  warning: 'bg-rose-50 border border-rose-200',
  positive: 'bg-sky-50 border border-sky-200'
};
const toneText: Record<string, string> = {
  neutral: 'text-abbvie-navy',
  warning: 'text-rose-700',
  positive: 'text-abbvie-navy'
};
export function CurrentStateScreen() {
  const reduceMotion = useReducedMotion();
  return <section className="flex min-h-screen items-center bg-presentation-canvas px-6 py-20" aria-labelledby="current-state-title" data-id="element-175" data-mp="3lfsppw4amim6">
      <div className="mx-auto w-full max-w-6xl" data-id="element-176" data-mp="1w1nwfex39v3r">
        <p className="mb-4 text-sm font-semibold text-primary" data-id="element-177" data-mp="1r2axvwwuuzlc">01 - Current state assessment</p>
        <h2 id="current-state-title" className="max-w-3xl text-4xl font-bold leading-tight text-secondary md:text-6xl" data-id="element-178" data-mp="1y1ya1mynyn8h">
          Two strong channels, one shared problem
        </h2>
        <p className="mt-5 max-w-2xl text-lg text-slate-500" data-id="element-179" data-mp="22yevuaie4pie">
          AbbVie Pro and the HCP websites it links to are trusted and comprehensive - but their depth is working against them.
        </p>

        <div className="mt-14 grid gap-4 sm:grid-cols-2" data-id="element-180" data-mp="2buxr3te3gpi5">
          {currentStateAssessment.map((item, index) => {
          const Icon = icons[index];
          return <motion.div key={item.label} initial={reduceMotion ? false : {
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.24,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`rounded-2xl p-6 ${tones[item.tone]}`} data-id="element-181" data-mp="2lpfwr432mv4l" data-mpi={index}>
                <Icon className={`h-6 w-6 ${toneText[item.tone]}`} aria-hidden="true" data-id="element-182" data-mp="10e7mgepbk5qn" />
                <p className={`mt-4 text-xs font-bold uppercase tracking-wide ${toneText[item.tone]} opacity-70`} data-id="element-183" data-mp="23pdc6a6wlkzp">{item.label}</p>
                <h3 className="mt-1 text-lg font-bold text-secondary" data-id="element-184" data-mp="1ys3ds51jdyzq">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-500" data-id="element-185" data-mp="2cnfb8k72u3kc">{item.detail}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}